/**
 * @generated SignedSource<<0e6b54a02c183775262cbbe58faa965c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineEditMainDeleteMutation$variables = {
  id: string;
};
export type RoutineEditMainDeleteMutation$data = {
  readonly routine: {
    readonly __typename: "RoutineMutation";
    readonly delete: boolean | null;
  } | null;
};
export type RoutineEditMainDeleteMutation = {
  response: RoutineEditMainDeleteMutation$data;
  variables: RoutineEditMainDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RoutineMutation",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "delete",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineEditMainDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineEditMainDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8726442fb42f127b942d1a76c3000ae4",
    "id": null,
    "metadata": {},
    "name": "RoutineEditMainDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation RoutineEditMainDeleteMutation(\n  $id: ID!\n) {\n  routine(id: $id) {\n    __typename\n    delete\n  }\n}\n"
  }
};
})();

(node as any).hash = "c106bafecff2c54de8817d1975df790c";

export default node;
